import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Router, ActivatedRoute } from '@angular/router';
import { _throw } from 'rxjs/observable/throw';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private route: ActivatedRoute
    ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = localStorage.getItem('token');
    
    if (token != null && req.url.includes('secured')) {

      if (req.url.includes('delete')) {
        req = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token
          } 
        });
      } else {
        req = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
          }
        });
      }
    }

    // return next.handle(req);
    return next.handle(req).catch(err => {
      // onError
      if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('data');
            localStorage.removeItem('message_404');
            if (this.router.url.search('dashboard') !== -1) {
              this.router.navigate(['../login'], {relativeTo: this.route});
            }
          }
          return _throw(err);
      }
    });
                
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/interceptor/authInterceptor.ts